export default __webpack_public_path__ + "static/media/mysql.9c9086e4.png";